import { Building2, Check, X, ExternalLink } from "lucide-react";
import { StatusBadge } from "./StatusBadge";

export const SheltersTab = ({ shelters, shelterFilter, setShelterFilter, onVerify }) => (
  <div>
    <div className="flex items-center gap-2 mb-4">
      <select
        value={shelterFilter}
        onChange={(e) => setShelterFilter(e.target.value)}
        className="input-minimal w-auto"
        data-testid="shelter-filter"
      >
        <option value="all">All Shelters</option>
        <option value="pending">Pending</option>
        <option value="verified">Verified</option>
        <option value="rejected">Rejected</option>
      </select>
    </div>

    <div className="space-y-3">
      {shelters.length === 0 ? (
        <div className="glass-card p-8 text-center">
          <Building2 className="w-12 h-12 text-[#3F3F46] mx-auto mb-3" />
          <p className="text-[#A1A1AA]">No shelters found</p>
        </div>
      ) : (
        shelters.map((shelter) => (
          <div key={shelter.shelter_id} className="glass-card p-4">
            <div className="flex items-start justify-between">
              <div className="flex-1">
                <div className="flex items-center gap-2 mb-1">
                  <h4 className="text-[#EDEDED] font-medium">{shelter.organization_name}</h4>
                  <StatusBadge status={shelter.verification_status} />
                </div>
                <p className="text-sm text-[#71717A]">
                  {shelter.location_city}, {shelter.location_state}
                </p>
                <div className="flex flex-wrap gap-4 mt-2 text-sm text-[#A1A1AA]">
                  {shelter.website_url && (
                    <a
                      href={shelter.website_url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="flex items-center gap-1 hover:text-[#D4AF37]"
                    >
                      <ExternalLink className="w-3 h-3" /> Website
                    </a>
                  )}
                  {shelter.ein && <span>EIN: {shelter.ein}</span>}
                  <span>Contact: {shelter.user_email}</span>
                </div>
                <p className="text-xs text-[#52525B] mt-2">
                  Species: {shelter.species?.join(", ") || "Not specified"}
                </p>
              </div>
              {shelter.verification_status === "pending" && (
                <div className="flex gap-2 ml-4">
                  <button
                    onClick={() => onVerify(shelter.shelter_id, "approve")}
                    className="p-2 rounded-lg bg-[#22C55E]/10 text-[#22C55E] hover:bg-[#22C55E]/20 transition-colors"
                    title="Approve"
                    data-testid={`approve-shelter-${shelter.shelter_id}`}
                  >
                    <Check className="w-5 h-5" />
                  </button>
                  <button
                    onClick={() => onVerify(shelter.shelter_id, "reject")}
                    className="p-2 rounded-lg bg-[#EF4444]/10 text-[#EF4444] hover:bg-[#EF4444]/20 transition-colors"
                    title="Reject"
                    data-testid={`reject-shelter-${shelter.shelter_id}`}
                  >
                    <X className="w-5 h-5" />
                  </button>
                </div>
              )}
            </div>
          </div>
        ))
      )}
    </div>
  </div>
);
